import View from './view';

import { hashify } from '../utils/arrays';

export default View.extend( {

    events: {
        'click .-level-up'(e) {
            this.trigger( 'property:level-up' );
        },

        'click .-enter-item'(e) {
            e.stopPropagation();

            const {propertyId} = e.currentTarget.dataset;
            const [propertyToEnter] = this.options.rootProperty
                .children.filter( property => property.id == propertyId );

            this.trigger( 'property:enter-item', propertyToEnter );
        },

        'click .-edit-start'(e) {
            e.stopPropagation();

            const {propertyId} = e.currentTarget.dataset;
            const [propertyToEdit] = this.options.rootProperty
                .children.filter( property => property.id == propertyId );

            if (propertyToEdit.is_terminal)
                this.trigger( 'terminal-property:edit-start', propertyToEdit );
            else
                this.trigger( 'intermediate-property:edit-start', propertyToEdit );
        },

        'click .-remove'(e) {
            e.stopPropagation();

            const {propertyId} = e.currentTarget.dataset;
            const [propertyToRemove] = this.options.rootProperty
                .children.filter( property => property.id == propertyId );

            this.trigger( 'property:remove', propertyToRemove );
        },

        'click .-remove-sibling'(e) {
            e.stopPropagation();

            const {propertyId} = e.currentTarget.dataset;
            const [propertyToRemove] = this.options.rootProperty
                .children.filter( property => property.id == propertyId );

            this.trigger( 'property:remove-sibling', propertyToRemove );
        },

        'click .-append-child-to'(e) {
            e.stopPropagation();

            const {propertyId} = e.currentTarget.dataset;
            const [propertyToAppendTo] = this.options.rootProperty
                .children.filter( property => property.id == propertyId );

            this.trigger( 'property:append-child-to', propertyToAppendTo );
        },

        'click .-show-possible-values'(e) {
            const {name} = e.target.dataset;
            this.trigger( 'property:show-possible-values', name );
        },
    },

    serialize() {
        const {isTop, rootProperty, activeProperty} = this.options;
        const {children} = rootProperty;
        const terminal = children.filter( property => !!property.is_terminal )
            .sort( (a, b) => {
                if (a.label < b.label) return -1;
                if (a.label > b.label) return 1;
                return 0;
            } );
        const preIntermediate = children.filter( property => !property.is_terminal );

        const hashed = hashify( preIntermediate, (childProperty, hash) => {
            const key = childProperty.name;
            const arrValue = hash[key] || [];
            arrValue.push( childProperty );
            return [key, arrValue];
        } );

        const intermediate = Object.keys( hashed )
            .map( key => hashed[key] )
            .map( siblings => {
                siblings.sort( (a, b) => a.array_index - b.array_index );

                const [{id, name, label, is_system}] = siblings;
                return {
                    id, 
                    name, label,
                    is_system,
                    siblings: siblings.length > 1 ? siblings : undefined,
                };
            } )
            .sort( (a, b) => {
                if (a.label < b.label) return -1;
                if (a.label > b.label) return 1;
                return 0;
            } );

        return {
            intermediate,
            terminal,
            activeProperty,
            isTop,
        };
    },

} );


// WEBPACK FOOTER //
// ./src/js/view/config.property.list.js